import script from "./ReservationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsPage.vue?vue&type=script&setup=true&lang=js"

import "./ReservationsPage.vue?vue&type=style&index=0&id=14d13704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d13704"]])

export default __exports__